import { render, staticRenderFns } from "./SpecialtyVisitMaterials.vue?vue&type=template&id=6c81bf7d"
import script from "./SpecialtyVisitMaterials.vue?vue&type=script&lang=js"
export * from "./SpecialtyVisitMaterials.vue?vue&type=script&lang=js"
import style0 from "./SpecialtyVisitMaterials.vue?vue&type=style&index=0&id=6c81bf7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports